import { useEffect, useState } from "react"

export default function ImageViewer(props) {
	const [manifestUrl, setManifestUrl] = useState(null);

	useEffect(() => {
		fetch(props.manifest)
			.then(res => res.json())
			.then(json => {
				console.log(json['@id'])
				if (json.items && json.items.length > 0) {
					setManifestUrl(props.manifest);
				}
				else {
					setManifestUrl(null);
				}
			})
	}, [props.manifest]);

	return manifestUrl && <div className="mb-5">
		<object type="text/html" 
			data={'//fornbref.arnastofnun.is/django/static/mirador/?manifest='+props.manifest+'&lang='+window.getCurrentLang()} 
			className="w-full h-[100vh] print:hidden" 
		/>

		<img className="hidden print:block w-full print:break-before-page" loading="lazy" src={'//fornbref.arnastofnun.is'+props.printImage.replace('/full/140,/', '/full/1122,/')} />
	</div>
}